import React from 'react';
import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';

import * as S from './style';

const SubSkeleton03 = () => (
  <S.Box className="sub-skeleton-03">
    <div className="box-top">
      <Skeleton className="main-banner" />
    </div>
    <Skeleton className="cont-title" />
    <div className="box-prd">
      <ul className="list">
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
      </ul>
      <ul className="list">
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
      </ul>
    </div>
  </S.Box>
);

export default SubSkeleton03;
